import React, { useState, useContext } from "react";
import { ThemeContext } from "../../context";
import "./admin.css";

const AdminLogin = ({ onLoginSuccess }) => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    const correctPassword = process.env.REACT_APP_ADMIN_PASSWORD || "admin";

    const handleLogin = (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        setTimeout(() => {
            if (password === correctPassword) {
                // Store session in sessionStorage (not localStorage for security)
                sessionStorage.setItem("adminAuthenticated", "true");
                onLoginSuccess();
            } else {
                setError("Invalid password. Please try again.");
            }
            setLoading(false);
            setPassword("");
        }, 300);
    };

    return (
        <div className={`admin-login-container ${darkMode ? 'dark' : 'light'}`}>
            <div className="admin-login-box">
                <h1 className="admin-login-title">Admin Portal</h1>
                <p className="admin-login-subtitle">Portfolio Management System</p>

                <form onSubmit={handleLogin} className="admin-login-form">
                    <div className="form-group">
                        <label htmlFor="password" className="form-label">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter admin password"
                            className={`form-input ${error ? 'error' : ''}`}
                            disabled={loading}
                            autoFocus
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button
                        type="submit"
                        className="btn-primary"
                        disabled={loading || !password}
                    >
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>

                <p className="admin-login-note">
                    ⚠️ This page is password protected. Only administrators should have access.
                </p>
            </div>
        </div>
    );
};

export default AdminLogin;
